export class WithdrawExecutionDate {
    public timeLimit: string;
    public willBeProcessedToday: boolean;
}
